/**
 * Action de la partie Course
 */
export const GET_CURRENT_COURSE = 'GET_CURRENT_COURSE';
export const GET_CURRENT_COURSE_SUCCESS = 'GET_CURRENT_COURSE_SUCCESS';
export const GET_CURRENT_COURSE_FAILURE = 'GET_CURRENT_COURSE_FAILURE';

export const getCurrentCourse = () => ({ type: GET_CURRENT_COURSE });

export const CREATE_COURSE = 'CREATE_COURSE';
export const CREATE_COURSE_FAILURE = 'CREATE_COURSE_FAILURE';
export const CREATE_COURSE_SUCCESS = 'CREATE_COURSE_SUCCESS';

export const createCourse = data => ({ type: CREATE_COURSE, payload: data });

export const CLOSE_DRAWER = 'CLOSE_DRAWER';
export const closeDrawer = () => ({ type: CLOSE_DRAWER });

export const OPEN_DRAWER = 'OPEN_DRAWER';
export const openDrawer = data => ({ type: OPEN_DRAWER, payload: data });

export const ADD_COMMANDS = 'ADD_COMMANDS';
export const ADD_COMMANDS_SUCCESS = 'ADD_COMMANDS_SUCCESS';
export const ADD_COMMANDS_FAILURE = 'ADD_COMMANDS_FAILURE';

export const addCommands = data => ({ type: ADD_COMMANDS, payload: data });

export const CANCEL_COURSE = 'CANCEL_COURSE';
export const CANCEL_COURS_SUCCESS = 'CANCEL_COURS_SUCCESS';
export const CANCEL_COURS_FAILURE = 'CANCEL_COURS_FAILURE';

export const cancelCourse = courseId => ({
  type: CANCEL_COURSE,
  payload: courseId
});
